<template>
  <div class="taxation">
    <!-- 头部 -->
    <zmlmenupage cn-name="企业筹划" en-name="Tax Planning"></zmlmenupage>

    <zmlpagebanner
      banner-img="static/img/proBanner.png"
      banner-text="货运江湖，一键启航！"
      cn-name="产品中心"
      en-name="Product Center"
    >
    </zmlpagebanner>

    <div class="taxation-box1">
      <div class="info taxationInfo flex">
        <div class="taxation-left">
          <div class="taxation-container flex">
            <div class="taxation-left-itme1">
              <img src="../../static/img/WechatIMG114.png" />
            </div>
            <div class="taxation-left-itme blurColor">
              <div class="taxation-left-itme1">
                <!-- <p>货运江湖</p>
							<p>一键开票</p>
							<p>合法合规</p> -->
                <img src="../../static/img/WechatIMG115.png" />
              </div>
            </div>
          </div>
        </div>
        <div class="taxation-right">
          <img src="../../static/img/WechatIMG113.png" alt="" />
        </div>
      </div>
    </div>

    <div class="taxation-box2">
      <taxation :taxation="false" class="taxation-zujian"></taxation>
    </div>

    <div class="taxation-box3">
      <div
        class="info taxationInfo"
        style="padding-left: 20px; padding-right: 20px"
      >
        <div class="taxation-box3-title">
          <p>企业<span>规划</span></p>
        </div>
        <div class="taxation-box3-swiper">
          <!-- <swiper ref="mySwiper" :options="swiperOptions">
					<swiper-slide>
						<div class="taxation-box3-swiper-img">
							<img src="../../static/img/sw1.png" alt="">
						</div>
						<p>广东省物流行业协会副会长单位</p>
					</swiper-slide>
					<swiper-slide>
						<div class="taxation-box3-swiper-img">
							<img src="../../static/img/sw2.png" alt="">
						</div>
						<p>广东省物流行业协会副会长单位</p>
					</swiper-slide>
					<swiper-slide>
						<div class="taxation-box3-swiper-img">
							<img src="../../static/img/sw3.png" alt="">
						</div>
						<p>广东省物流行业协会副会长单位</p>
					</swiper-slide>
				</swiper> -->
          <div class="taxation-content-con">
            <div class="taxation-content-icon">
              <div class="taxation-icon">
                <img src="../../static/img/tax1.png" width="95" alt="" />
                <p>平台用户专享</p>
                <p>地方经营补贴</p>
              </div>
              <span class="taxation-span"></span>
              <div class="taxation-icon">
                <img src="../../static/img/tax2.png" width="95" alt="" />
                <p>一对一</p>
                <p>VIP服务专员</p>
              </div>
              <span class="taxation-span"></span>
              <div class="taxation-icon">
                <img src="../../static/img/tax3.png" width="95" alt="" />
                <p>企业物流规划</p>
                <p>及优化方案定制</p>
              </div>
              <span class="taxation-span"></span>
              <div class="taxation-icon flexItems">
                <img src="../../static/img/tax4.png" width="95" alt="" />
                <p>网络货运代征试点单位</p>
                <p>解决运输白条难题</p>
              </div>
              <span class="taxation-span"></span>
              <div class="taxation-icon flexItems">
                <img src="../../static/img/tax5.png" width="95" alt="" />
                <p>优化企业运输成本</p>
                <p>保障业务链条完整</p>
              </div>
              <span class="taxation-span"></span>
              <div class="taxation-icon flexItems">
                <img src="../../static/img/tax6.png" width="95" alt="" />
                <p>轨迹真实，合法合规</p>
                <p>杜绝您的点滴经营风险</p>
              </div>
            </div>
            <!-- <div class="taxation-content-text flex">
						<div class="taxation-textItem">
							<p>平台用户专享</p>
							<p>税务补贴</p>
						</div>
						<div class="taxation-textItem">
							<p>一对一</p>
							<p>VIP服务专员</p>
						</div>
						<div class="taxation-textItem">
							<p>企业税务规划</p>
							<p>及优化方案定制</p>
						</div>
						<div class="taxation-textItem">
							<p>提供真正合规运输发票</p>
							<p>解决运输税务难题</p>
						</div>
						<div class="taxation-textItem">
							<p>优化企业税赋成本</p>
							<p>保障企业税务安全</p>
						</div>
						<div class="taxation-textItem">
							<p>轨迹真实，合法合规</p>
							<p>杜绝您的点滴经营风险</p>
						</div>
					</div> -->
          </div>
        </div>
      </div>
    </div>

    <!-- 以下移动端显示 -->
    <div class="phone-tax">
      <div class="phone-tax-box">
        <img src="../../static/img/phone-tax.png" alt="" />
        <div class="taxation-left-itme1">
          <img src="../../static/img/tax.png" />
        </div>
      </div>
      <div class="phone-tax-box" style="background-color: #fff">
        <div class="taxation-left-itme blurColor">
          <!-- <div class="taxation-left-itme-text2">
					<p>提供真正合规运输发票，解决运输税务难题</p>
					<p>控制企业税赋成本，保障企业税务安全</p>
					<p>轨迹真实，合法合规，杜绝您的点滴经营风险</p>
				</div> -->
        </div>
        <div class="taxation-content-left"><span>五流合一</span>真实数据源</div>
        <div class="taxation-content-right">
          <p>企业运输方案提前做，管家式服务更省心</p>
          <p>货运江湖，您征战市场，决胜“江湖”的忠实伙伴</p>
        </div>
        <div class="phone-tax-box-icons">
          <div class="phone-tax-box-icons-icon flexItems">
            <img src="../../static/img/phoneIcon1.png" alt="" />
            <div class="phone-tax-box-icons-icon-text">
              <p>合同流</p>
              <p>与船东、司机、货主分别签订电子运输合同，合法合规</p>
            </div>
          </div>
          <div class="phone-tax-box-icons-icon flexItems">
            <img src="../../static/img/phoneIcon2.png" alt="" />
            <div class="phone-tax-box-icons-icon-text">
              <p>货物流</p>
              <p>货物从源头开始，所有流转过程清晰，有据可查</p>
            </div>
          </div>
          <div class="phone-tax-box-icons-icon flexItems">
            <img src="../../static/img/phoneIcon3.png" alt="" />
            <div class="phone-tax-box-icons-icon-text">
              <p>资金流</p>
              <p>清晰明了的资金走向，各环节合法合规</p>
            </div>
          </div>
          <div class="phone-tax-box-icons-icon flexItems">
            <img src="../../static/img/phoneIcon4.png" alt="" />
            <div class="phone-tax-box-icons-icon-text">
              <p>票据流</p>
              <p>平台为货主提供合法增值税运输税票</p>
            </div>
          </div>
          <div class="phone-tax-box-icons-icon flexItems">
            <img src="../../static/img/phoneIcon5.png" alt="" />
            <div class="phone-tax-box-icons-icon-text">
              <p>信息流</p>
              <p>大数据采集、整理、加工‘实时推送各类信息</p>
            </div>
          </div>
        </div>
      </div>
      <div class="phone-tax-box">
        <div class="taxation-box3-title">
          <p>企业规划</p>
        </div>
        <div class="phone-tax-box-boxs">
          <!-- <div class="phone-tax-box-item">
					<img src="../../static/img/sw1.png" alt="">
					<p>广东省物流行业协会副会长单位</p>
				</div>
				<div class="phone-tax-box-item">
					<img src="../../static/img/sw2.png" alt="">
					<p>广东省物流行业协会副会长单位</p>
				</div>
				<div class="phone-tax-box-item">
					<img src="../../static/img/sw3.png" alt="">
					<p>广东省物流行业协会副会长单位</p>
				</div> -->
          <div class="phone-tax-box-icons">
            <div class="phone-tax-box-icons-icon flexItems">
              <img src="../../static/img/tax-phone-1.png" alt="" />
              <div class="phone-tax-box-icons-icon-text">
                <p>平台用户专享</p>
                <p>地方经营补贴</p>
              </div>
            </div>
            <div class="phone-tax-box-icons-icon flexItems">
              <img src="../../static/img/tax-phone-2.png" alt="" />
              <div class="phone-tax-box-icons-icon-text">
                <p>一对一</p>
                <p>VIP服务专员</p>
              </div>
            </div>
            <div class="phone-tax-box-icons-icon flexItems">
              <img src="../../static/img/tax-phone-3.png" alt="" />
              <div class="phone-tax-box-icons-icon-text">
                <p>企业物流规划</p>
                <p>及优化方案定制</p>
              </div>
            </div>
            <div class="phone-tax-box-icons-icon flexItems">
              <img src="../../static/img/tax-phone-4.png" alt="" />
              <div class="phone-tax-box-icons-icon-text">
                <p>网络货运代证试点单位</p>
                <p>解决运输白条难题</p>
              </div>
            </div>
            <div class="phone-tax-box-icons-icon flexItems">
              <img src="../../static/img/tax-phone-5.png" alt="" />
              <div class="phone-tax-box-icons-icon-text">
                <p>优化企业运输成本</p>
                <p>保障业务链条完整</p>
              </div>
            </div>
            <div class="phone-tax-box-icons-icon flexItems">
              <img src="../../static/img/tax-phone-6.png" alt="" />
              <div class="phone-tax-box-icons-icon-text">
                <p>轨迹真实，合法合规</p>
                <p>杜绝您的点滴经营风险</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <gototop></gototop>
  </div>
</template>
<script>
import taxation from "@/components/index_taxation.vue";
export default {
  name: "Taxation",
  data() {
    return {
      swiperOptions: {
        slidesPerView: 3,
      },
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  components: {
    taxation,
  },
};
</script>
<style scoped="scoped">
.taxation {
  background-color: #fff;
}

.taxationInfo {
  padding: 100px 1.7%;
}

.taxation-title {
  font-weight: bold;
  margin-bottom: 10px;
}

.taxation-left {
  width: 900px;
  height: auto;
  display: flex;
  flex-flow: column;
  justify-content: space-between;
}

.taxation-container {
  box-shadow: -5px 0px 10px 0 rgba(0, 0, 0, 0.1);
}

.taxation-left-itme {
  width: 450px;
  height: 523px;
  background-color: #fff;
  text-align: center;
}

.taxation-left-itme1 {
  width: 450px;
  height: 523px;
  background-color: #fff;
}

.taxation-left-itme1 img {
  width: 100%;
  height: 100%;
}

.taxation-right {
  width: auto;
  height: 523px;
  box-shadow: 0 0 10px 0 rgba(0, 0, 0, 0.1);
}
.taxation-right img {
  width: 450px;
  height: 523px;
}

.taxation-left-itme-text1 {
  font-size: 54px;
  margin-top: 100px;
}
.taxation-left-itme-text1 p {
  margin-bottom: 10px;
}

.taxation-left-itme-text2 {
  color: #666666;
  line-height: 32px;
}

.blurColor {
  background-color: #127bfd;
  color: #fff;
}

.blurColor .taxation-left-itme-text2 {
  color: #fff;
}

.taxation-box2 {
  background-color: #fff;
  width: 100%;
  height: auto;
  margin-top: -250px;
  padding-top: 200px;
}

>>> .taxation-content {
  height: auto;
  padding-bottom: 100px;
}

.taxation-box3 {
  width: 100%;
  height: 630px;
  overflow: hidden;
  margin-top: -100px;
}

.taxation-box3-title {
  font-size: 54px;
}

.taxation-box3-title span {
  color: #127bfd;
}

.taxation-box3-swiper {
  padding-top: 16px;
}

.taxation-box3-swiper img {
  width: 100%;
}

.swiper-container {
  overflow: inherit;
}

.swiper-slide {
  transition: 0.3s;
}

.swiper-slide p {
  margin-top: 20px;
  font-size: 16px;
  color: #666;
  padding-left: 20px;
}

.swiper-slide:nth-of-type(2) {
  transform: translateY(-100px);
}

.phone-tax {
  display: none;
}

.taxation-span {
  display: block;
  width: 5px;
  height: 130px;
  background-color: #f4f4f6;
  /* margin-left: 90px; */
  /* margin: 0 30%; */
}

.taxation-textItem {
  min-width: 218px;
  margin-right: 0.98rem;
}

.taxation-textItem > p:nth-of-type(1) {
  font-size: 16px;
  color: #282828;
  line-height: 26px;
  margin-top: 28px;
}

.taxation-textItem > p:nth-of-type(2) {
  color: #666;
  font-size: 16px;
  line-height: 26px;
  margin-top: 28px;
}

.taxation-content-con {
  padding-top: 96px;
}

.taxation-content-icon {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}
.taxation-icon {
  display: table-cell;
  vertical-align: middle;
  text-align: center;
  width: 16%;
}
.taxation-icon img {
  display: inline-block;
  width: 70px;
}
.taxation-icon > p:nth-of-type(1) {
  font-size: 16px;
  color: #282828;
  line-height: 26px;
  margin-top: 28px;
}
.taxation-icon > p:nth-of-type(2) {
  color: #666;
  font-size: 16px;
  line-height: 26px;
  margin-top: 28px;
}
@media only screen and (max-width: 1600px) {
  .taxation-zujian >>> .taxation-content-con {
    padding-top: 100px;
  }
  .taxation-box3-swiper {
    padding-top: 16px;
  }
}
@media only screen and (max-width: 1400px) {
  .taxation-zujian >>> .taxation-content-con {
    padding-top: 100px;
  }

  .taxation-textItem {
    min-width: 180px;
  }
  .taxation-box3-swiper {
    padding-top: 16px;
  }
}
@media only screen and (max-width: 750px) {
  /* .phone-tax-box-boxs img {
		display: inline-block;
		width: 400px;
		height: 150px;
	} */
  .taxation-title {
    padding: 23px 0;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 0;
  }
  .taxation-box1,
  .taxation-box2,
  .taxation-box3 {
    display: none;
  }
  .phone-tax {
    background-color: #fff;
    display: block;
    padding-bottom: 100px;
  }
  .phone-tax-box {
    padding: 0 23px;
  }
  .phone-tax-box img {
    width: 100%;
  }
  .taxation-left-itme {
    width: 100%;
    height: auto;
    padding: 23px;
  }
  .taxation-left-itme1 {
    width: 100%;
    height: auto;
  }
  .taxation-left-itme-text1 {
    font-size: 27px;
    font-weight: bold;
    margin-top: 20px;
    margin-bottom: 20px;
  }
  .taxation-left-itme-text2 {
    font-size: 13px;
    line-height: 22px;
  }
  .taxation-content-left {
    font-size: 27px;
    letter-spacing: 4px;
    margin-top: 50px;
    margin-bottom: 20px;
    font-weight: bold;
  }
  .taxation-content-left span {
    color: #127bfd;
    margin-right: 20px;
  }
  .taxation-content-right {
    text-align: left;
    font-size: 14px;
    color: #282828;
    line-height: 26px;
  }
  .phone-tax-box-icons {
    padding-top: 20px;
    padding-bottom: 40px;
  }
  .phone-tax-box-icons-icon {
    margin: 20px 0;
  }
  .phone-tax-box-icons-icon img {
    width: 66px;
    margin-right: 10px;
  }
  .phone-tax-box-icons-icon-text {
    flex: 1;
  }
  .phone-tax-box-icons-icon-text p:nth-of-type(1) {
    font-size: 16px;
    font-weight: bold;
  }
  .phone-tax-box-icons-icon-text p:nth-of-type(2) {
    color: #666666;
    font-size: 13px;
    line-height: 18px;
    margin-top: 5px;
  }
  .taxation-box3-title {
    font-size: 27px;
    font-weight: bold;
    padding-top: 30px;
  }
  .phone-tax-box-item {
    margin-top: 30px;
  }
  .phone-tax-box-item img {
    width: 100%;
  }
  .phone-tax-box-item p {
    text-align: center;
    font-size: 15px;
    font-weight: bold;
    margin-top: 10px;
  }
  .taxation-content-con {
    padding-top: 30px;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/taxation.vue